class InnovationGrid {
  constructor(section) {
    this.section = section;
    this.accordionTriggers = this.section.querySelectorAll('[data-accordion-trigger]');
    this.init();
  }

  init() {
    // Only enable accordion behavior on mobile
    if (this.accordionTriggers.length === 0) return;

    this.accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', this.toggleAccordion.bind(this));
    });

    // Handle window resize
    this.handleResize();
    window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 250));

    this.openFirstOnMobile();

  }

  toggleAccordion(event) {
    // Only work on mobile
    if (window.innerWidth >= 990) return;

    const trigger = event.currentTarget;
    const item = trigger.closest('[data-accordion-item]');
    const content = item.querySelector('[data-accordion-content]');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    // Toggle state
    trigger.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('data-open', !isExpanded);
  }

  handleResize() {
    // Reset accordion state when switching to desktop
    if (window.innerWidth >= 990) {
      this.accordionTriggers.forEach((trigger) => {
        const item = trigger.closest('[data-accordion-item]');
        const content = item.querySelector('[data-accordion-content]');
        
        trigger.setAttribute('aria-expanded', 'false');
        content.removeAttribute('data-open');
      });
    }
  }

  openFirstOnMobile() {
  if (window.innerWidth >= 990) return;

  const firstItem = this.section.querySelector('[data-accordion-item]');
  if (!firstItem) return;

  const trigger = firstItem.querySelector('[data-accordion-trigger]');
  const content = firstItem.querySelector('[data-accordion-content]');

  if (!trigger || !content) return;

  trigger.setAttribute('aria-expanded', 'true');
  content.setAttribute('data-open', 'true');
}


  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize all innovation grid sections
document.addEventListener('DOMContentLoaded', () => {
  const innovationSections = document.querySelectorAll('.section-innovation-grid');
  innovationSections.forEach((section) => {
    new InnovationGrid(section);
  });
});